import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { useI18n } from "@/i18n";

export default function AvisoLegal() {
  const { lang } = useI18n();
  const isEs = lang === "es";

  return (
    <div className="min-h-screen bg-obsidian text-gold-light">
      <header className="border-b border-gold-subtle bg-obsidian-2/60 backdrop-blur">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" data-testid="aviso-legal-back-home">
            <Logo />
          </Link>
          <Link to="/" className="text-xs text-faded hover:text-gold">
            ← Volver
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-display text-4xl mb-2">Aviso Legal</h1>
        <p className="text-xs text-faded mb-12">
          Última actualización: 25 de mayo de 2026 · v1.0-2026-05-25
        </p>

        {!isEs && (
          <LegalLangNotice lang={lang} />
        )}

        {isEs && (
          <div className="space-y-8 text-sm leading-relaxed">
            <section>
              <h2 className="font-display text-2xl text-gold mb-3">
                1. Identificación del titular (LSSI-CE art. 10)
              </h2>
              <p className="mb-3">
                En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios
                de la Sociedad de la Información y de Comercio Electrónico
                (LSSI-CE), se ponen a disposición de los usuarios los siguientes
                datos identificativos del titular del sitio web{" "}
                <a
                  href="https://keepsoul.app"
                  className="text-gold hover:underline"
                >
                  keepsoul.app
                </a>
                :
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>
                  <strong>Nombre comercial:</strong> KeepSoul
                </li>
                <li>
                  <strong>Titular:</strong> Antonio Ferrer García
                </li>
                {/* PRIVACY-NIF-HIDDEN — restaurar NIF real o sustituir por CIF de SL antes de lanzamiento público */}
                <li>
                  <strong>Identificación fiscal:</strong> disponible bajo
                  solicitud a{" "}
                  <a
                    href="mailto:support@keepsoul.app"
                    className="text-gold hover:underline"
                  >
                    support@keepsoul.app
                  </a>
                </li>
                {/* PRIVACY-ADDRESS-HIDDEN — restaurar o sustituir por domicilio profesional antes de lanzamiento público */}
                <li>
                  <strong>Domicilio:</strong> Murcia, España (dirección postal
                  disponible bajo solicitud a{" "}
                  <a
                    href="mailto:support@keepsoul.app"
                    className="text-gold hover:underline"
                  >
                    support@keepsoul.app
                  </a>{" "}
                  para asuntos legales y notificaciones)
                </li>
                <li>
                  <strong>Forma jurídica:</strong> persona física (autónomo)
                </li>
                <li>
                  <strong>Email de contacto:</strong>{" "}
                  <a
                    href="mailto:support@keepsoul.app"
                    className="text-gold hover:underline"
                  >
                    support@keepsoul.app
                  </a>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-display text-2xl text-gold mb-3">
                2. Objeto
              </h2>
              <p>
                El presente Aviso Legal regula las condiciones generales de
                acceso y uso del sitio web{" "}
                <a
                  href="https://keepsoul.app"
                  className="text-gold hover:underline"
                >
                  keepsoul.app
                </a>{" "}
                y de la aplicación KeepSoul (en adelante, "el Sitio"). El acceso
                al Sitio atribuye a quien lo realiza la condición de Usuario e
                implica la aceptación plena y sin reservas del presente Aviso
                Legal, así como de la Política de Privacidad, la Política de
                Cookies y, en su caso, de los Términos y Condiciones del
                servicio.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl text-gold mb-3">
                3. Condiciones de acceso y uso
              </h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>
                  El acceso al Sitio es libre y gratuito. La utilización de
                  determinados servicios podrá estar condicionada al registro
                  previo del Usuario y al pago de las contraprestaciones
                  económicas establecidas.
                </li>
                <li>
                  El Usuario se compromete a utilizar el Sitio conforme a la
                  legislación vigente, a la buena fe, al orden público y a
                  estas condiciones.
                </li>
                <li>
                  Queda prohibido el uso del Sitio con fines ilícitos o lesivos
                  contra los derechos e intereses de terceros, así como la
                  realización de cualquier acción que pueda dañar, inutilizar
                  o sobrecargar el Sitio.
                </li>
                <li>
                  El Usuario es responsable de la veracidad de los datos
                  facilitados y de mantener actualizada la información de su
                  cuenta.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-display text-2xl text-gold mb-3">
                4. Propiedad intelectual e industrial
              </h2>
              <p>
                Todos los contenidos del Sitio (textos, imágenes, sonido,
                marcas, logotipos, combinaciones de colores, estructura,
                diseño, selección de materiales utilizados, programas
                informáticos y bases de datos) son titularidad del titular
                indicado o de terceros que han autorizado su uso, y están
                protegidos por la legislación española e internacional sobre
                propiedad intelectual e industrial. El contenido subido por el
                Usuario (Cofre, mensajes, herencias digitales) sigue siendo
                propiedad del Usuario y KeepSoul únicamente lo almacena
                cifrado para prestar el servicio contratado.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl text-gold mb-3">
                5. Hosting y prestadores técnicos
              </h2>
              <p>
                El Sitio se aloja en infraestructura cloud profesional ubicada
                en la Unión Europea.{" "}
                <strong>
                  Proveedor de hosting: [pendiente de confirmar]
                </strong>
                . Cualquier modificación se reflejará en esta página y, cuando
                corresponda, en la Política de Privacidad.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl text-gold mb-3">
                6. Exclusión de responsabilidad
              </h2>
              <p>
                KeepSoul no se hace responsable de los daños y perjuicios que
                pudieran derivarse de interferencias, omisiones,
                interrupciones, virus informáticos, averías o desconexiones en
                el funcionamiento operativo del sistema electrónico motivadas
                por causas ajenas a KeepSoul, ni de los retrasos o bloqueos en
                el uso causados por deficiencias o sobrecargas de líneas
                telefónicas o de Internet, ni de los daños causados por
                terceras personas mediante intromisiones ilegítimas fuera del
                control de KeepSoul. La limitación de responsabilidad
                específica del servicio se regula en los{" "}
                <Link
                  to="/legal/terminos"
                  className="text-gold hover:underline"
                >
                  Términos y Condiciones
                </Link>
                .
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl text-gold mb-3">
                7. Legislación aplicable y jurisdicción
              </h2>
              <p>
                El presente Aviso Legal se rige por la legislación española.
                Para la resolución de cualquier controversia derivada del
                acceso o uso del Sitio, las partes se someten expresamente a
                los Juzgados y Tribunales de Murcia (España), salvo que el
                Usuario tenga la condición de consumidor, en cuyo caso se
                estará a su fuero legal según el TRLGDCU.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl text-gold mb-3">
                8. Contacto
              </h2>
              <p>
                Para cualquier consulta relacionada con este Aviso Legal puedes
                contactar en{" "}
                <a
                  href="mailto:support@keepsoul.app"
                  className="text-gold hover:underline"
                >
                  support@keepsoul.app
                </a>
                .
              </p>
            </section>
          </div>
        )}

        <div className="mt-12 pt-6 border-t border-gold-subtle text-xs text-faded text-center space-x-3">
          <Link to="/legal/privacidad" className="hover:text-gold">
            Privacidad
          </Link>
          <span className="text-faded/40">·</span>
          <Link to="/legal/terminos" className="hover:text-gold">
            Términos
          </Link>
          <span className="text-faded/40">·</span>
          <Link to="/legal/cookies" className="hover:text-gold">
            Cookies
          </Link>
          <span className="text-faded/40">·</span>
          <Link to="/" className="hover:text-gold">
            Inicio
          </Link>
        </div>
      </main>
    </div>
  );
}

function LegalLangNotice({ lang }) {
  if (lang === "zh") {
    return (
      <div className="rounded border border-gold-subtle bg-obsidian-2/40 p-5 text-sm leading-relaxed">
        <p className="mb-2 text-gold-light">
          法律文件目前以西班牙语提供,西班牙语是依据西班牙消费者法律管辖本合同的语言。
        </p>
        <p className="text-faded">
          英文和中文译本即将提供。如需说明,请联系:{" "}
          <a
            href="mailto:support@keepsoul.app"
            className="text-gold hover:underline"
          >
            support@keepsoul.app
          </a>
        </p>
      </div>
    );
  }
  return (
    <div className="rounded border border-gold-subtle bg-obsidian-2/40 p-5 text-sm leading-relaxed">
      <p className="mb-2 text-gold-light">
        The legal documentation is currently available in Spanish, which is the
        language governing the contract under Spanish consumer law.
      </p>
      <p className="text-faded">
        An English translation will be available soon. For clarifications:{" "}
        <a
          href="mailto:support@keepsoul.app"
          className="text-gold hover:underline"
        >
          support@keepsoul.app
        </a>
      </p>
    </div>
  );
}
